import React, { useCallback, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ContentCopyIcon } from '@/shared/ui/display/EmojiIcon';
import { fontSize, typography } from '@/shared/theme';

interface AddressSpanProps {
  value: string;
}

/**
 * 주소 등 복사 기능이 항상 붙는 텍스트 스팬
 */
export function AddressSpan({ value }: AddressSpanProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  }, [value]);

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: fontSize.sm,
          fontWeight: typography.cell.fontWeight,
          color: 'text.primary',
        }}
      >
        {value}
      </Typography>
      <IconButton
        size="small"
        onClick={handleCopy}
        sx={{
          padding: '2px',
          color: 'text.secondary',
          '&:hover': {
            color: 'text.primary',
            backgroundColor: 'action.hover',
          },
        }}
        title={copied ? '복사됨' : '복사'}
      >
        <ContentCopyIcon sx={{ fontSize: 14 }} />
      </IconButton>
    </Box>
  );
}
